/*
  Wishlist de Marti (Swym Wishlist Plus), modelo nativo de Swym: por variante.

  - Tarjeta ([data-sb-wishlist][data-context="card"]): talla unica -> guarda o
    quita directamente. Con tallas -> abre el selector de talla
    (snippets/sb-wishlist-size-picker.liquid), que muestra las tallas guardadas
    y permite guardar o quitar una talla concreta.
  - Ficha ([data-context="pdp"]): regla de talla de Add to cart
    (assets/custom.js). Con talla elegida guarda o quita esa variante; sin
    talla pide elegirla y no modifica la lista.
  - Header ([data-sb-wishlist-open]): abre el drawer nativo de Swym.

  Solo APIs documentadas por Swym: SwymCallbacks, swat.api.fetchLists /
  createList / addToList / deleteFromList, swat.evtLayer + swat.JSEvents,
  swat.ui.open. El drawer no se toca; el aviso de "guardado" lo muestra Swym.
  Si Swym o el producto no cargan, no se guarda nada.
*/
(function () {
  if (window.sbWishlist) return;

  var SELECTOR = '[data-sb-wishlist]';
  var LIST_NAME = 'My Wishlist';
  var SWYM_TIMEOUT = 8000;
  // items: empi -> [{epi, empi, du}]; saved: epi -> true
  var state = { swat: null, lid: null, items: {}, saved: {} };
  var products = {}; // handle -> Promise<product.js>
  var syncTimer = null;
  var paintTimer = null;

  function warn(err) {
    console.warn('[sb-wishlist]', err);
  }

  // ---------------------------------------------------------------------
  // Swym
  // ---------------------------------------------------------------------
  var ready = new Promise(function (resolve) {
    function init(swat) {
      state.swat = swat;
      var events = swat.JSEvents;
      // Tambien llegan cuando se quita o se anade desde el drawer nativo
      swat.evtLayer.addEventListener(events.addedToWishlist, scheduleSync);
      swat.evtLayer.addEventListener(events.removedFromWishlist, scheduleSync);
      sync().catch(warn).then(resolve);
    }

    // Swym sustituye push() y ejecuta al momento los callbacks que llegan tarde
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(init);
  });

  // Swym no carga sin consentimiento de preferencias o si su servidor falla.
  // Sin consentimiento no tiene sentido esperar: se avisa al momento.
  function swymReady() {
    if (!state.swat && unavailableMessage() === 'consent') return Promise.reject(new Error('swym-no-consent'));
    return Promise.race([
      ready,
      new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject(new Error('swym-timeout'));
        }, state.swat ? 0 : SWYM_TIMEOUT);
      }),
    ]).then(function () {
      if (!state.swat) throw new Error('swym-timeout');
    });
  }

  function call(method, args) {
    return new Promise(function (resolve, reject) {
      state.swat.api[method].apply(state.swat.api, args.concat([resolve, reject]));
    });
  }

  // Con tiempo maximo: si Swym no responde, nada se queda esperando (selector abierto,
  // marcador bloqueado); el estado se corrige en la siguiente lectura o evento.
  function sync() {
    return Promise.race([
      new Promise(function (resolve, reject) {
        state.swat.api.fetchLists({ callbackFn: resolve, errorFn: reject });
      }),
      new Promise(function (resolve, reject) {
        setTimeout(function () {
          reject(new Error('swym-fetch-timeout'));
        }, SWYM_TIMEOUT);
      }),
    ]).then(function (lists) {
      var list = lists && lists[0];
      state.lid = list ? list.lid : null;
      state.items = {};
      state.saved = {};
      ((list && list.listcontents) || []).forEach(function (item) {
        var key = String(item.empi);
        (state.items[key] = state.items[key] || []).push({ epi: item.epi, empi: item.empi, du: item.du });
        state.saved[item.epi] = true;
      });
      paint();
      if (picker) picker.refresh();
    });
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      sync().catch(warn);
    }, 300);
  }

  function ensureList() {
    if (state.lid) return Promise.resolve(state.lid);
    return call('createList', [{ lname: LIST_NAME }]).then(function (list) {
      state.lid = list.lid;
      return list.lid;
    });
  }

  function productUrl(handle) {
    return window.location.origin + '/products/' + handle;
  }

  function add(epi, empi, handle) {
    return ensureList().then(function (lid) {
      return call('addToList', [lid, { epi: Number(epi), empi: Number(empi), du: productUrl(handle) }]);
    });
  }

  function remove(entries) {
    return ensureList().then(function (lid) {
      return Promise.all(
        entries.map(function (entry) {
          return call('deleteFromList', [lid, entry]);
        })
      );
    });
  }

  function entriesFor(empi, epi) {
    return (state.items[String(empi)] || []).filter(function (entry) {
      return epi == null || Number(entry.epi) === Number(epi);
    });
  }

  // Sin consentimiento de preferencias Swym no carga: se explica y se ofrece gestionarlo
  function unavailableMessage() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    var noConsent = privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed() !== true;
    return noConsent ? 'consent' : 'error';
  }

  // ---------------------------------------------------------------------
  // Datos de producto de Shopify (cacheados tras la primera carga)
  // ---------------------------------------------------------------------
  function loadProduct(handle) {
    if (!products[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      products[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('product-' + response.status);
          return response.json();
        })
        .catch(function (err) {
          delete products[handle]; // un fallo no se cachea
          throw err;
        });
    }
    return products[handle];
  }

  // ---------------------------------------------------------------------
  // Selector de talla (tarjetas)
  // ---------------------------------------------------------------------
  var picker = (function () {
    var el = null;
    var current = null; // { btn, handle, empi, product, selected }
    var lastFocus = null;

    function node(selector) {
      return el && el.querySelector(selector);
    }

    function label(name) {
      return (el && el.getAttribute('data-label-' + name)) || '';
    }

    function setup() {
      if (el) return el;
      el = document.querySelector('[data-sb-size-picker]');
      if (!el) return null;
      // Fuera del header: un ancestro con transform romperia position: fixed
      document.body.appendChild(el);

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-sb-picker-close]')) {
          close();
          return;
        }
        var size = event.target.closest('[data-sb-picker-size]');
        if (size && !size.disabled && current) {
          current.selected = Number(size.getAttribute('data-sb-picker-size'));
          render();
          return;
        }
        if (event.target.closest('[data-sb-picker-submit]')) submit();
        if (event.target.closest('[data-sb-picker-consent]') && window.privacyBanner) window.privacyBanner.showPreferences();
      });

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });
      return el;
    }

    function show() {
      el.hidden = false;
      document.documentElement.classList.add('sb-size-picker-open');
      var panel = node('.sb-size-picker__panel');
      if (panel) panel.focus();
    }

    function close() {
      if (!el || el.hidden) return;
      el.hidden = true;
      document.documentElement.classList.remove('sb-size-picker-open');
      current = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function message(kind) {
      var box = node('[data-sb-picker-message]');
      var consent = node('[data-sb-picker-consent]');
      if (!box) return;
      box.hidden = !kind;
      box.textContent = kind ? label(kind) : '';
      if (consent) consent.hidden = !(kind === 'consent' && window.privacyBanner);
    }

    function setBusy(busy) {
      el.classList.toggle('is-busy', busy);
    }

    function render() {
      if (!current || !current.product) return;
      var product = current.product;
      var sizes = node('[data-sb-picker-sizes]');
      var submitBtn = node('[data-sb-picker-submit]');

      sizes.innerHTML = '';
      product.variants.forEach(function (variant) {
        var saved = !!state.saved[variant.id];
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'sb-size-picker__size';
        button.setAttribute('data-sb-picker-size', variant.id);
        button.setAttribute('aria-pressed', current.selected === variant.id ? 'true' : 'false');
        // Una talla agotada que ya estaba guardada se puede seleccionar para quitarla
        button.disabled = !variant.available && !saved;
        if (!variant.available) button.classList.add('is-sold-out');
        if (saved) button.classList.add('is-saved');

        var name = document.createElement('span');
        name.textContent = variant.title;
        button.appendChild(name);
        if (saved || !variant.available) {
          var note = document.createElement('span');
          note.className = 'sb-size-picker__note';
          note.textContent = saved ? label('saved') : label('sold-out');
          button.appendChild(note);
        }
        sizes.appendChild(button);
      });

      var selectedSaved = current.selected != null && !!state.saved[current.selected];
      submitBtn.disabled = current.selected == null;
      submitBtn.textContent = selectedSaved ? label('remove') : label('save');
    }

    function fillProduct(product) {
      var image = node('[data-sb-picker-image]');
      var src = product.featured_image;
      if (image && src) {
        image.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=240';
        image.alt = product.title;
        image.hidden = false;
      }
      node('[data-sb-picker-title]').textContent = product.title;
    }

    function open(btn) {
      if (!setup()) return;
      lastFocus = btn;
      current = { btn: btn, handle: btn.dataset.handle, empi: Number(btn.dataset.productId), product: null, selected: null };
      var token = current;
      el.classList.remove('is-message');

      // Estado de carga: datos de la tarjeta mientras llega el producto
      node('[data-sb-picker-title]').textContent = btn.dataset.title || '';
      node('[data-sb-picker-price]').textContent = btn.dataset.price || '';
      var image = node('[data-sb-picker-image]');
      if (image) image.hidden = true;
      node('[data-sb-picker-sizes]').innerHTML = '';
      node('[data-sb-picker-submit]').disabled = true;
      node('[data-sb-picker-submit]').textContent = label('save');
      message(null);
      setBusy(true);
      show();

      Promise.all([loadProduct(current.handle), swymReady()])
        .then(function (results) {
          if (current !== token) return;
          current.product = results[0];
          fillProduct(results[0]);
          render();
        })
        .catch(function (err) {
          warn(err);
          if (current !== token) return;
          message(state.swat ? 'error' : unavailableMessage());
        })
        .then(function () {
          if (current === token) setBusy(false);
        });
    }

    // Aviso suelto (talla unica, ficha, header) cuando Swym no esta disponible
    function openMessage(btn, kind) {
      if (!setup()) return;
      lastFocus = btn;
      current = null;
      node('[data-sb-picker-title]').textContent = '';
      node('[data-sb-picker-price]').textContent = '';
      var image = node('[data-sb-picker-image]');
      if (image) image.hidden = true;
      node('[data-sb-picker-sizes]').innerHTML = '';
      node('[data-sb-picker-submit]').disabled = true;
      el.classList.add('is-message');
      message(kind);
      setBusy(false);
      show();
    }

    function submit() {
      if (!current || current.selected == null || el.classList.contains('is-busy')) return;
      var token = current;
      var epi = current.selected;
      var saving = !state.saved[epi];
      setBusy(true);
      message(null);

      // El aviso de "guardado" lo muestra el propio Swym (evento addedToWishlist).
      // Se cierra en cuanto Swym confirma; la relectura de la lista va en segundo plano.
      var action = saving ? add(epi, current.empi, current.handle) : remove(entriesFor(current.empi, epi));
      action.then(
        function () {
          setBusy(false);
          if (current === token) close();
          sync().catch(warn);
        },
        function (err) {
          warn(err);
          setBusy(false);
          if (current === token) message('error');
          sync().catch(warn);
        }
      );
    }

    return {
      open: open,
      openMessage: openMessage,
      close: close,
      refresh: function () {
        if (current && current.product && el && !el.hidden) render();
      },
    };
  })();

  // ---------------------------------------------------------------------
  // Ficha de producto: misma regla de talla que Add to cart (assets/custom.js)
  // ---------------------------------------------------------------------
  function pdpScope(btn) {
    return btn.closest('product-info') || btn.closest('.shopify-section') || document;
  }

  function isSizeSelected(sizeWrapper) {
    var checkedRadio = sizeWrapper.querySelector('input[type="radio"]:checked');
    if (checkedRadio) return true;

    var popoutInput = sizeWrapper.querySelector('[data-popout-input]');
    if (popoutInput) return popoutInput.value.trim() !== '';

    var nativeSelect = sizeWrapper.querySelector('select');
    if (nativeSelect) return nativeSelect.value.trim() !== '';

    return true;
  }

  function missingSizes(scope) {
    return Array.prototype.filter.call(scope.querySelectorAll('[data-size-selector]'), function (wrapper) {
      return !isSizeSelected(wrapper);
    });
  }

  // Variante del formulario de compra real (no el de pagos a plazos)
  function pdpSelection(btn) {
    var scope = pdpScope(btn);
    var input = scope.querySelector('form[data-product-form] [name="id"]');
    return {
      scope: scope,
      sizeChosen: missingSizes(scope).length === 0,
      variantId: input && input.value ? Number(input.value) : Number(btn.dataset.variantId),
    };
  }

  // Mismo aviso que Add to cart sin talla; el tema lo quita al elegir talla
  function showSizeError(btn, scope) {
    missingSizes(scope).forEach(function (wrapper) {
      wrapper.classList.add('size-selector--missing');
      wrapper.setAttribute('aria-invalid', 'true');
    });
    btn.classList.remove('size-selector-shake');
    void btn.offsetWidth;
    btn.classList.add('size-selector-shake');
  }

  // Tras elegir talla, el tema actualiza la variante por AJAX (data-variant-pending)
  function whenVariantSettled(scope) {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        if (!scope.hasAttribute || !scope.hasAttribute('data-variant-pending') || tries++ > 20) return resolve();
        setTimeout(check, 150);
      })();
    });
  }

  // ---------------------------------------------------------------------
  // Estado de los marcadores
  // ---------------------------------------------------------------------
  function isOn(btn) {
    var saved = state.items[btn.dataset.productId];
    if (!saved) return false;
    if (btn.dataset.context !== 'pdp') return true;

    var sel = pdpSelection(btn);
    // Sin talla elegida: relleno solo como indicador de que hay alguna talla guardada
    if (!sel.sizeChosen) return true;
    return !!state.saved[sel.variantId];
  }

  function paint() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      var on = isOn(btn);
      var label = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      if (btn.dataset.context === 'card' && btn.dataset.needsSize === 'true') {
        label = btn.dataset.labelChoose || label;
      } else if (on && btn.dataset.context === 'pdp' && !pdpSelection(btn).sizeChosen) {
        label = btn.dataset.labelSaved || label;
      }
      if (btn.getAttribute('aria-pressed') !== String(on)) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    });
    paintCount();
  }

  // Contador del icono del header: entradas de la lista (una por talla, como el drawer).
  // Solo con la lista ya leida de Swym y con al menos 1 producto.
  function paintCount() {
    var count = 0;
    Object.keys(state.items).forEach(function (key) {
      count += state.items[key].length;
    });
    var text = count > 99 ? '99+' : String(count);
    var hide = !state.swat || count === 0;
    document.querySelectorAll('[data-sb-wishlist-count]').forEach(function (badge) {
      if (badge.hidden !== hide) badge.hidden = hide;
      if (badge.textContent !== text) badge.textContent = text;
    });
  }

  function schedulePaint() {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(paint, 100);
  }

  // ---------------------------------------------------------------------
  // Clics
  // ---------------------------------------------------------------------
  // Guardar o quitar una variante concreta (talla unica en tarjeta, o talla elegida en ficha).
  // Se relee la lista al terminar, tambien si falla, para corregir el estado optimista.
  function toggleVariant(btn, epi) {
    var entries = entriesFor(btn.dataset.productId, epi);
    var saving = !entries.length;
    btn.setAttribute('aria-pressed', saving ? 'true' : 'false');
    return (saving ? add(epi, btn.dataset.productId, btn.dataset.handle) : remove(entries))
      .catch(warn)
      .then(function () {
        return sync().catch(warn);
      });
  }

  function handle(btn) {
    btn.classList.add('is-busy');
    var work;

    if (btn.dataset.context === 'card' && btn.dataset.needsSize === 'true') {
      picker.open(btn);
      work = Promise.resolve();
    } else {
      var pdp = btn.dataset.context === 'pdp';
      var settled = pdp ? whenVariantSettled(pdpScope(btn)) : Promise.resolve();
      work = settled
        .then(function () {
          if (pdp) {
            var sel = pdpSelection(btn);
            if (!sel.sizeChosen) {
              showSizeError(btn, sel.scope);
              return null;
            }
            return sel.variantId;
          }
          return Number(btn.dataset.variantId);
        })
        .then(function (epi) {
          if (epi == null) return;
          return swymReady().then(
            function () {
              return toggleVariant(btn, epi);
            },
            function () {
              picker.openMessage(btn, unavailableMessage());
            }
          );
        });
    }

    work.catch(warn).then(function () {
      btn.classList.remove('is-busy');
    });
  }

  function openDrawer(trigger) {
    swymReady().then(
      function () {
        state.swat.ui.open();
      },
      function () {
        picker.openMessage(trigger, unavailableMessage());
      }
    );
  }

  // Captura: el marcador de la tarjeta esta junto al enlace del producto, que no debe abrirse
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      var opener = event.target.closest('[data-sb-wishlist-open]');
      if (opener) {
        event.preventDefault();
        openDrawer(opener);
        return;
      }
      var btn = event.target.closest(SELECTOR);
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      if (!btn.classList.contains('is-busy')) handle(btn);
    },
    true
  );

  // Cambio de talla en la ficha: el icono refleja la talla elegida
  document.addEventListener('change', schedulePaint);

  // Tarjetas que llegan despues (filtros, busqueda, recomendaciones) y re-render de la ficha
  new MutationObserver(schedulePaint).observe(document.documentElement, { childList: true, subtree: true });

  window.sbWishlist = { sync: sync };
})();
